import type { MainlineRow, MainlineRowInput, Proposal, RowKind } from '@services/drbfm.mainline';
export const fields: Record<RowKind, string[]> = {
  design_change: ['category', 'item_name', 'old_specification', 'new_specification', 'change_description'],
  failure_mode: ['failure_description', 'failure_cause', 'failure_effect', 'severity_score',
    'occurrence_score', 'detection_score', 'countermeasure_requirement', 'countermeasure_not_required_reason'],
  countermeasure: ['description', 'countermeasure_type', 'target_cause', 'mechanism',
    'verification_method', 'acceptance_criteria'],
};
export const groups = { design_change: 'design_changes', failure_mode: 'failure_modes',
  countermeasure: 'countermeasures' } as const;
export const parentKinds = { failure_mode: 'design_change', countermeasure: 'failure_mode' } as const;
export const rowTitle = (row: MainlineRow) => String(row.change_description || row.failure_description || row.description || row.id);
export const isAccepted = (row: MainlineRow) => ['accepted', 'modified'].includes(row.review_status)
  && !row.mainline_metadata?.needs_recheck;
export function editValue(kind: RowKind, row?: MainlineRow): MainlineRowInput {
  const values: MainlineRowInput = { kind, fields: {}, unknown_conditions: row?.mainline_metadata?.unknown_conditions
    ?? (row?.unknown_assumptions as string[] | undefined) ?? [], evidence: row?.mainline_metadata?.evidence ?? [] };
  fields[kind].forEach(key => {
    const value = row?.[key];
    if (typeof value === 'string' || typeof value === 'number') values.fields[key] = value;
  });
  if (kind === 'failure_mode' && row?.mainline_metadata?.severity_confirmed === false) values.fields.severity_score = null;
  if (!row && kind === 'design_change') values.fields.category = 'その他';
  return values;
}
// The server predicts the reset with the comparison apply uses; older proposals lack it, so warn.
export function revisionResetsReviewedScore(p: Proposal, selected: string[]): boolean {
  if (p.kind !== 'failure_mode' || p.before?.score_status !== 'reviewed' || !selected.length) return false;
  const reset = p.score_reset;
  return !reset || reset.conditions_or_evidence || selected.some(key => reset.fields.includes(key));
}
